
import React from "react";
import { VictoryLine, VictoryChart, VictoryAxis, VictoryScatter, VictoryTheme, InterpolationPropType } from "victory";
import { ChartLineModel } from "../../model/chart/ChartLineModel";


type ChartProps = {
    width: number | string | undefined;
    height?: number | undefined;
    data: ChartLineModel;
    tickValues: number[];
    interpolation: InterpolationPropType;
    showTitle: boolean;
};

export default function ChartLine(props: ChartProps) {

    const colors = ["#FF0000", "#00FF00", "#0000FF", "#FFFF00", "#FF00FF", "#00FFFF", "#800000", "#008000", "#000080", "#808080"];

    let dados = props.data.lines[0]?.data || [];

    let labels = dados.map((item, index) => item.nameX);
    let values = dados.map((item, index) => index);

    return (
        <div style={{ width: props.width }}>
            {props.showTitle && <p style={{ fontSize: 20, fontWeight: "bold", color: "#000", textAlign: "center" }}>{props.data.title}</p>}
            <VictoryChart
                theme={VictoryTheme.material}
                domainPadding={20}
                height={props.height}
                padding={{ top: 10, bottom: 30, left: 60, right: 10 }}
            >
                <VictoryAxis
                    tickValues={values}
                    tickFormat={labels}
                    style={{
                        tickLabels: { fontSize: 9 }
                    }}
                    
                />
                <VictoryAxis
                    dependentAxis
                    tickValues={props.tickValues}
                    tickFormat={(x) => (`R$${x.toFixed(2).replace(".", ",")}`)}
                    style={{
                        tickLabels: { fontSize: 9 }
                    }}
                />

                {props.data.lines.map((d, i) => {
                    return <VictoryLine
                        key={i}
                        data={d.data}
                        style={{ data: { stroke: colors[i] } }}
                        y={(datum) => datum.y}
                        interpolation={props.interpolation}
                    />
                })}

                {props.data.lines.map((d, i) => {
                    return <VictoryScatter
                        key={i}
                        data={d.data}
                        style={{ data: { fill: colors[i] } }}
                        y={(datum) => datum.y}

                    />
                })}

            </VictoryChart>
            <div style={{ display: "flex", alignItems: "center", justifyItems: "center", paddingLeft: 20, paddingBottom: 10 }}>
                {props.data.lines.map((d, i) => {
                    return <div style={{ display: "flex", marginRight: 10, alignItems: "center", justifyItems: "center" }} key={i}>
                        <div style={{ height: 10, width: 10, marginRight: 3, backgroundColor: colors[i], borderWidth: 1 }}></div>
                        <span style={{ justifySelf: "center", textAlign: "center", alignSelf: "center" }}>{d.name}</span>
                    </div>
                })}

            </div>
        </div>
    );
}

ChartLine.defaultProps = {
    width: 500,
    height: 200,
    tickValues: null,
    interpolation: "linear",
    showTitle: true
};